module.exports = __webpack_public_path__ + "img/invite-icon-modal.1f821a2c.svg";